import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { environment } from '@accredible-frontend-v2/envs';
import { CustomHeaderLink } from '@accredible-frontend-v2/models';
import { AccredibleBrowserStorageService } from '@accredible-frontend-v2/services/browser-storage';
import { ThemeGeneratorService } from '@accredible-frontend-v2/services/theme-generator';
import { Component, OnInit } from '@angular/core';
import { ThemeHelper } from '@spotlight/domain';

const THEME_HEADER_CONFIG = 'themeHeaderConfig';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent implements OnInit {
  extraHeaderLinks: AccredibleResponsiveMenuItem[];
  extraLinksLoaded = false;

  private _themeHeaderConfig: { customHeaderLinks: CustomHeaderLink[] };
  private _themeName = ThemeHelper.getTheme();

  constructor(
    private readonly _browserStorage: AccredibleBrowserStorageService,
    private readonly _themeGeneratorService: ThemeGeneratorService,
  ) {}

  ngOnInit(): void {
    if (environment.theming) {
      this._themeHeaderConfig = this._browserStorage.get(THEME_HEADER_CONFIG)
        ? JSON.parse(this._browserStorage.get(THEME_HEADER_CONFIG))
        : null;

      if (this._themeHeaderConfig) {
        this.extraHeaderLinks = this._themeGeneratorService.createCustomHeaderLinks(
          this._themeHeaderConfig.customHeaderLinks,
        );
      }

      this.extraLinksLoaded = true;
    } else {
      this._themeGeneratorService.getThemeHeaderLinks(this._themeName).subscribe({
        next: (res) => {
          this.extraHeaderLinks = this._themeGeneratorService.createCustomHeaderLinks(
            res.customHeaderLinks,
          );
          this.extraLinksLoaded = true;
        },
        error: () => {
          this.extraLinksLoaded = true;
        },
      });
    }
  }
}
